export default `/* Ids Layout Grid Cell */
:host {
  line-height: normal;
}

:host(.editable),
.editable {
  position: relative;
  border: 1px solid var(--ids-color-palette-blue-20);
}

::slotted(.close-btn),
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
}

/* Auto-fit grid with siblings layout */
:host(.ids-layout-grid-auto-fit-container) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-data-grid[auto-fit]) {
  flex: 1 1 auto;
  min-height: 200px;
  width: 100%;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(:not(ids-data-grid)) {
  flex: 0 0 auto;
}
:host(.ids-layout-grid-auto-fit-container) ::slotted(ids-button) {
  align-self: baseline;
}

/* When a cell contains an auto-fit data grid (no siblings),
   constrain the cell so height: 100% resolves against the grid track */
:host(.ids-layout-grid-auto-fit-container.ids-layout-grid-no-siblings) {
  block-size: 100%;
  min-block-size: 0;
  min-inline-size: 0;
  overflow: visible;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
